// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__c\\+bHf {
  margin: 0 2rem;
  padding: 1rem;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.styles_header__U\\+M4X {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.styles_title__qmXjq {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1 1;
}

.styles_titleText__L7S5y {
  color: #18316e;
  font-family: "Abhaya Libre", serif;
  font-size: 2rem;
  font-weight: 600;
  margin: 0;
  padding: 0;
}

.styles_headerActions__UKu1i {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.styles_filtrosCard__ShW3M {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  overflow: hidden;
}

.styles_filtrosHeader__ZIVKK {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  color: #0d2847;
  font-weight: 600;
}

.styles_iconFilter__EDBVS {
  color: #1e4a7a;
  font-size: 1.5rem;
}


.styles_tableCard__GYC\\+K {
  background: white;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.styles_tableCard__GYC\\+K table {
  width: 100%;
}

.styles_tableCard__GYC\\+K th {
  background-color: #f5f7fa;
  color: #0d2847;
  font-weight: 600;
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 2px solid #e0e0e0;
  position: sticky;
  top: 0;
  z-index: 10;
  white-space: nowrap;
}

.styles_tableCard__GYC\\+K td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: middle;
}

.styles_tableCard__GYC\\+K tr:hover {
  background-color: #f9f9f9;
}

.styles_tableCard__GYC\\+K a {
  cursor: pointer;
}

.styles_tableCard__GYC\\+K button {
  white-space: nowrap;
}

.styles_tableCard__GYC\\+K .styles_MuiChip-root__Orv7A {
  border-radius: 16px;
}

@media (max-width: 1024px) {
  .styles_header__U\\+M4X {
    flex-direction: column;
    align-items: flex-start;
  }

  .styles_headerActions__UKu1i {
    width: 100%;
    flex-wrap: wrap;
  }

  .styles_filtrosCard__ShW3M {
    padding: 1rem;
  }
}

@media (max-width: 768px) {
  .styles_container__c\\+bHf {
    margin: 0 1rem;
    padding: 0.5rem;
  }

  .styles_titleText__L7S5y {
    font-size: 1.5rem;
  }

  .styles_tableCard__GYC\\+K {
    overflow-x: auto;
  }

  .styles_tableCard__GYC\\+K table {
    min-width: 800px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Importadores/styles.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".container {\n  margin: 0 2rem;\n  padding: 1rem;\n  background-color: #f5f7fa;\n  min-height: 100vh;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.title {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  flex: 1;\n}\n\n.titleText {\n  color: #18316e;\n  font-family: \"Abhaya Libre\", serif;\n  font-size: 2rem;\n  font-weight: 600;\n  margin: 0;\n  padding: 0;\n}\n\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.filtrosCard {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.filtrosHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  color: #0d2847;\n  font-weight: 600;\n}\n\n.iconFilter {\n  color: #1e4a7a;\n  font-size: 1.5rem;\n}\n\n\n.tableCard {\n  background: white;\n  border-radius: 12px;\n  padding: 1rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.tableCard table {\n  width: 100%;\n}\n\n.tableCard th {\n  background-color: #f5f7fa;\n  color: #0d2847;\n  font-weight: 600;\n  padding: 0.75rem 1rem;\n  text-align: left;\n  border-bottom: 2px solid #e0e0e0;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  white-space: nowrap;\n}\n\n.tableCard td {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #e0e0e0;\n  vertical-align: middle;\n}\n\n.tableCard tr:hover {\n  background-color: #f9f9f9;\n}\n\n.tableCard a {\n  cursor: pointer;\n}\n\n.tableCard button {\n  white-space: nowrap;\n}\n\n.tableCard .MuiChip-root {\n  border-radius: 16px;\n}\n\n@media (max-width: 1024px) {\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .headerActions {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .filtrosCard {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    margin: 0 1rem;\n    padding: 0.5rem;\n  }\n\n  .titleText {\n    font-size: 1.5rem;\n  }\n\n  .tableCard {\n    overflow-x: auto;\n  }\n\n  .tableCard table {\n    min-width: 800px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__c+bHf`,
	"header": `styles_header__U+M4X`,
	"title": `styles_title__qmXjq`,
	"titleText": `styles_titleText__L7S5y`,
	"headerActions": `styles_headerActions__UKu1i`,
	"filtrosCard": `styles_filtrosCard__ShW3M`,
	"filtrosHeader": `styles_filtrosHeader__ZIVKK`,
	"iconFilter": `styles_iconFilter__EDBVS`,
	"tableCard": `styles_tableCard__GYC+K`,
	"MuiChip-root": `styles_MuiChip-root__Orv7A`
};
export default ___CSS_LOADER_EXPORT___;
